import { useQuery } from '@tanstack/react-query';
import { useRef, useEffect, useMemo } from 'react';
import { useGetNotificationsQuery } from './api.get-notifications.query.js';

function useQueryWithNotifications(queryOptions, mergeCb) {
  const mergeCbRef = useRef(mergeCb);
  const query = useQuery(queryOptions);
  const notifications = useGetNotificationsQuery();
  useEffect(() => {
    mergeCbRef.current = mergeCb;
  }, [mergeCb]);

  // re-create the QueryResult object, merging data from the two queries using
  // the provided mergeCb()
  return {
    data: useMemo(() => query.data && notifications.data ? mergeCbRef.current(query.data, notifications.data) : undefined, [notifications.data, query.data]),
    dataUpdatedAt: Math.max(query.dataUpdatedAt, notifications.dataUpdatedAt),
    isPlaceholderData: query.isPlaceholderData || notifications.isPlaceholderData,
    status: query.status === "error" || notifications.status === "error" ? "error" : query.status === "pending" || notifications.status === "pending" ? "pending" : "success",
    fetchStatus: query.fetchStatus === "fetching" || notifications.fetchStatus === "fetching" ? "fetching" : query.fetchStatus === "paused" || notifications.fetchStatus === "paused" ? "paused" : "idle",
    failureCount: query.failureCount + notifications.failureCount,
    failureReason: query.failureReason || notifications.failureReason,
    isSuccess: query.isSuccess && notifications.isSuccess,
    isPaused: query.isPaused || notifications.isPaused,
    isStale: query.isStale || notifications.isStale,
    isLoading: query.isLoading || notifications.isLoading,
    isLoadingError: query.isLoadingError || notifications.isLoadingError,
    isPending: query.isPending || notifications.isPending,
    isFetched: query.isFetched || notifications.isFetched,
    isFetching: query.isFetching || notifications.isFetching,
    isFetchedAfterMount: query.isFetchedAfterMount || notifications.isFetchedAfterMount,
    isRefetching: query.isRefetching || notifications.isRefetching,
    isRefetchError: query.isRefetchError || notifications.isRefetchError,
    isError: query.isError || notifications.isError,
    error: query.error || notifications.error,
    errorUpdatedAt: Math.max(query.errorUpdatedAt, notifications.errorUpdatedAt),
    errorUpdateCount: query.errorUpdateCount + notifications.errorUpdateCount
  };
}

export { useQueryWithNotifications };
//# sourceMappingURL=hook.query-with-notifications.js.map
